<template>
  <div class="severity-pill">
    <PillBadge
      v-tooltip="{
        content: 'Vulnerability severity',
        placement: tooltipPlacement,
      }"
      black
      :small="small"
    >
      <div class="severity-pill__content">
        <div
          :class="[
            'severity-pill__bars',
            `severity-pill__bars-${severity.toLowerCase()}`,
          ]"
        >
          <div class="severity-pill__bars-bar"></div>
          <div class="severity-pill__bars-bar"></div>
          <div class="severity-pill__bars-bar"></div>
          <div class="severity-pill__bars-bar"></div>
        </div>
        <div class="severity-pill__label">
          {{ severityLabel }}
        </div>
      </div>
    </PillBadge>
  </div>
</template>

<script>
import PillBadge from '@/components/shared/PillBadge.vue'

export default {
  name: 'SeverityPill',
  components: {
    PillBadge,
  },
  props: {
    severity: {
      type: String,
      required: true,
      default: '',
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'right-center',
    },
  },
  computed: {
    severityLabel() {
      let label = 'Unknown'
      switch (this.severity.toLowerCase()) {
        case 'critical':
          label = 'Critical'
          break
        case 'high':
          label = 'High'
          break
        case 'medium':
          label = 'Medium'
          break
        case 'low':
          label = 'Low'
          break
      }
      return label
    },
  },
}
</script>

<style lang="scss" scoped>
.severity-pill {
  cursor: pointer;
  max-width: 90px;
  &__content {
    display: flex;
    align-items: baseline;
    gap: 5px;
    width: 100%;
    justify-content: center;
    &--small {
      height: 23px;
    }
  }
  &__bars {
    $this: &;
    width: 21px;
    display: flex;
    gap: 3px;
    align-items: baseline;
    &-bar {
      width: 3px;
      border-radius: 0.5px;
      background: #444;
      &:nth-of-type(1) {
        height: 4px;
      }
      &:nth-of-type(2) {
        height: 6px;
      }
      &:nth-of-type(3) {
        height: 8px;
      }
      &:nth-of-type(4) {
        height: 10px;
      }
    }
    &-low {
      #{$this}-bar {
        &:nth-of-type(1) {
          background: var(--extra-light-gray);
        }
      }
    }
    &-medium {
      #{$this}-bar {
        &:nth-of-type(1) {
          background: var(--performance-average);
        }
        &:nth-of-type(2) {
          background: var(--performance-average);
        }
      }
    }
    &-high {
      #{$this}-bar {
        &:nth-of-type(1) {
          background: var(--performance-avg-negative);
        }
        &:nth-of-type(2) {
          background: var(--performance-avg-negative);
        }
        &:nth-of-type(3) {
          background: var(--performance-avg-negative);
        }
      }
    }
    &-critical {
      #{$this}-bar {
        &:nth-of-type(1) {
          background: var(--red-two);
        }
        &:nth-of-type(2) {
          background: var(--red-two);
        }
        &:nth-of-type(3) {
          background: var(--red-two);
        }
        &:nth-of-type(4) {
          background: var(--red-two);
        }
      }
    }
  }
}
</style>
